import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { baseTransitionSecond, grayscaleFilter } from 'style/variables';
import { InView } from 'react-intersection-observer';

type ScrollGrayCoverProps = {
  rootMargin?: string;
  triggerOnce?: boolean;
  children: React.ReactNode;
};

const GrayCoverWrap = styled.div<{ isInView?: boolean }>`
  position: absolute !important;
  inset: 0;
  backdrop-filter: ${grayscaleFilter};
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
  transition: backdrop-filter ${baseTransitionSecond * 3}s ease-out;
  z-index: 1;

  ${({ isInView }) =>
    isInView &&
    css`
      backdrop-filter: none;
    `}
`;

const Container = styled.div`
  position: relative;
  display: inline-block;
`;

const ScrollGrayCover: React.FC<ScrollGrayCoverProps> = ({ rootMargin = '-30% 0px', triggerOnce = false, children }) => {
  return (
    <InView triggerOnce={triggerOnce} rootMargin={rootMargin} threshold={0.1}>
      {({ inView, ref }) => (
        <Container ref={ref}>
          {children}
          <GrayCoverWrap isInView={inView} />
        </Container>
      )}
    </InView>
  );
};

export default ScrollGrayCover;
